<template>
  <div class="login-slider">
    <Transition name="login-slider-fade" mode="out-in">
      <article :key="activeItem.title" class="login-slider-card">
        <div class="login-slider-icon-wrap">
          <img :src="activeItem.image" :alt="activeItem.title" class="login-slider-icon" />
        </div>

        <div class="login-slider-copy">
          <span class="login-slider-tag">{{ activeItem.tag }}</span>
          <h3>{{ activeItem.title }}</h3>
          <p>{{ activeItem.description }}</p>
        </div>
      </article>
    </Transition>

    <div class="login-slider-dots" aria-hidden="true">
      <span
        v-for="(item, index) in items"
        :key="item.title"
        class="login-slider-dot"
        :class="{ 'login-slider-dot-active': index === activeIndex }"
      ></span>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import accountingImage from "../../assets/images/statics/ciencias-economicas.png";
import salesImage from "../../assets/images/statics/carrito-de-compras.png";
import storageImage from "../../assets/images/statics/pilas-de-almacenamiento.png";

export default {
  name: "LoginSlider",
  setup() {
    const activeIndex = ref(0);

    const items = [
      {
        tag: "Contabilidad",
        title: "Reportes optimizados",
        description: "Visualiza resultados claros para el área contable y mantén control financiero.",
        image: accountingImage,
      },
      {
        tag: "Ventas",
        title: "Cobro ágil y seguro",
        description: "Gestiona ventas, clientes y órdenes desde un mismo flujo operativo.",
        image: salesImage,
      },
      {
        tag: "Almacén",
        title: "Stock bajo control",
        description: "Supervisa kardex, inventario físico y movimientos sin perder trazabilidad.",
        image: storageImage,
      },
    ];

    const activeItem = computed(() => items[activeIndex.value]);
    let rotationInterval = null;

    onMounted(() => {
      rotationInterval = window.setInterval(() => {
        activeIndex.value = (activeIndex.value + 1) % items.length;
      }, 3200);
    });

    onBeforeUnmount(() => {
      if (rotationInterval) {
        window.clearInterval(rotationInterval);
      }
    });

    return {
      activeItem,
      activeIndex,
      items,
    };
  },
};
</script>

<style scoped>
.login-slider {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.login-slider-card {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.9rem;
  align-items: center;
  min-height: 6.2rem;
  border: 1px solid rgba(120, 188, 255, 0.12);
  border-radius: 1rem;
  padding: 0.95rem 1rem;
  background: linear-gradient(180deg, rgba(20, 91, 132, 0.26), rgba(12, 54, 85, 0.35));
}

.login-slider-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.3rem;
  height: 3.3rem;
  border-radius: 0.95rem;
  background: rgba(112, 181, 255, 0.08);
}

.login-slider-icon {
  width: 2.15rem;
  height: 2.15rem;
  object-fit: contain;
}

.login-slider-copy {
  min-width: 0;
}

.login-slider-tag {
  display: inline-flex;
  margin-bottom: 0.35rem;
  color: #75b9ff;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-slider-copy h3 {
  margin: 0;
  color: #ffffff;
  font-size: 0.98rem;
  font-weight: 700;
}

.login-slider-copy p {
  margin: 0.2rem 0 0;
  color: rgba(214, 230, 255, 0.72);
  font-size: 0.82rem;
  line-height: 1.45;
}

.login-slider-dots {
  display: flex;
  justify-content: center;
  gap: 0.45rem;
}

.login-slider-dot {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 9999px;
  background: rgba(148, 199, 255, 0.24);
  transition: transform 0.2s ease, background 0.2s ease;
}

.login-slider-dot-active {
  background: #61abff;
  transform: scale(1.6);
}

.login-slider-fade-enter-active,
.login-slider-fade-leave-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}

.login-slider-fade-enter-from,
.login-slider-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@media (max-width: 767px) {
  .login-slider-card {
    min-height: auto;
    padding: 0.85rem 0.9rem;
  }

  .login-slider-copy p {
    font-size: 0.78rem;
  }
}
</style>
